export default "__VITE_ASSET__DYWMC5zC__"